module.exports = __webpack_public_path__ + "static/media/login5_catwalk.08d19715.svg";